
// Vue
import {Options, Vue} from "vue-class-component";

// Models
import {AppCoachPlayersCategoriesListFormRemove} from "@/models/app/coach/players/categories/list/form/remove";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElDialog,
  ElForm,
  ElFormItem,
  ElButton,
} from "element-plus";
import {Delete} from "@element-plus/icons-vue";
import {AppCoachPlayersCategoriesListFormUpdate} from "@/models/app/coach/players/categories/list/form/update";

// Services
import {postRequest} from "@/services/api/request";

@Options({
  props: [
    "playerCategory",
  ],
  components: {
    ElDialog,
    ElForm,
    ElFormItem,
    ElButton,
    Delete,
  },
})
export default class AppCoachPlayersCategoriesListFormRemoveIndexVue extends Vue {
  isLoading: boolean | null = false;
  isDialogVisible: boolean | null = false;

  playerCategory: AppCoachPlayersCategoriesListFormUpdate = new AppCoachPlayersCategoriesListFormUpdate();

  formData: AppCoachPlayersCategoriesListFormRemove = new AppCoachPlayersCategoriesListFormRemove();

  $refs!: {
    formComponent: HTMLFormElement;
  };

  validateForm(): void {
    this.$refs.formComponent.validate((response: any) => {
      if (response) {
        this.submitForm();
      }
    });
  }

  async submitForm(): Promise<void> {
    this.isLoading = true;
    await postRequest({
      uri: "/administration/player-category/remove",
      formData: this.formData,
      isProtected: true,
      isSuccessNotificationVisible: true,
      isErrorNotificationVisible: true,
    }).then((r: ResponseIndex) => {
      if (r.status === "success") {
        this.$emit('getPlayerCategories');
        this.isDialogVisible = false;
        this.resetFormData();
      }
    });
    this.isLoading = false;
  }

  setFormData(): void {
    this.formData = this.playerCategory;
  }

  resetFormData(): void {
    this.formData = new AppCoachPlayersCategoriesListFormRemove();
  }

  updated(): void {
    this.setFormData();
  }
}
